import { useMemo } from 'react';
import { Clock, TrendingDown, TrendingUp } from 'lucide-react';

import { FullPageContent } from '@/components/layout/full-page-content';

import { ContractsTable } from '../components/contracts-table';
import { StatsCard } from '../components/stats-card';
import { ContractsQuery } from '../queries/contracts.query';

export function ContractsPage() {
  const contracts = ContractsQuery.useQuery();

  const statistics = useMemo(() => {
    const contractsWithStatus = contracts.data?.contracts ?? [];

    const active = contractsWithStatus.filter(
      (c) => c.status === 'active',
    ).length;
    const inactive = contractsWithStatus.filter(
      (c) => c.status === 'inactive',
    ).length;
    const expiringSoon = contractsWithStatus.filter(
      (c) => c.status === 'expiring-soon',
    ).length;

    return { active, inactive, expiringSoon };
  }, [contracts.data?.contracts]);

  return (
    <FullPageContent testId="contracts-page">
      <div className="container mx-auto flex h-full flex-col p-6">
        <div className="mb-8 flex flex-col gap-4 md:flex-row md:items-center md:justify-between">
          <div>
            <h1 className="mb-2 font-condensed text-3xl font-bold tracking-tight">
              Subscriptions
            </h1>
            <p className="max-w-prose text-lg text-muted-foreground">
              Monitor all your active and inactive subscriptions
            </p>
          </div>
        </div>

        <div className="min-h-0 flex-1 overflow-y-auto">
          <div className="space-y-6">
            <div className="rounded-md border">
              <ContractsTable />
            </div>
          </div>
        </div>

        <div className="my-6 shrink-0">
          <div className="grid gap-4 md:grid-cols-3">
            <StatsCard
              data-testid="stats-card-active"
              title="Active Subscriptions"
              value={statistics.active}
              description="Currently running subscriptions"
              color="text-green-600"
              isLoading={contracts.isLoading}
              icon={<TrendingUp className="size-4" />}
            />
            <StatsCard
              data-testid="stats-card-inactive"
              title="Inactive Subscriptions"
              value={statistics.inactive}
              description="Expired or future subscriptions"
              color="text-gray-600"
              isLoading={contracts.isLoading}
              icon={<TrendingDown className="size-4" />}
            />
            <StatsCard
              data-testid="stats-card-expiring-soon"
              title="Expiring Soon"
              value={statistics.expiringSoon}
              description="Ending within 30 days"
              color="text-orange-600"
              isLoading={contracts.isLoading}
              icon={<Clock className="size-4" />}
            />
          </div>
        </div>
      </div>
    </FullPageContent>
  );
}
